import React from "react";
import { usePublicConfig } from "../lib/usePublicConfig";

export default function Footer() {
    const cfg = usePublicConfig();
    return (
        <footer className="mt-20 border-t border-slate-200 bg-slate-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 text-sm text-slate-600">
                <div className="grid gap-8 md:grid-cols-3">
                    <div>
                        <div className="font-heading font-bold text-[#0F172A] text-base">CCS Cost Calculator Australia</div>
                        <p className="mt-2 text-slate-500">Free childcare cost estimates for Australian families based on the latest CCS rules.</p>
                    </div>
                    <div>
                        <div className="font-semibold text-[#0F172A] mb-2">Disclaimer</div>
                        <p className="text-slate-500">
                            This calculator provides an estimate only. Actual CCS amounts are determined by{" "}
                            <a href="https://www.servicesaustralia.gov.au/child-care-subsidy" target="_blank" rel="noreferrer" className="text-[#1E3A8A] underline">Services Australia</a>.
                        </p>
                    </div>
                    <div>
                        <div className="font-semibold text-[#0F172A] mb-2">Contact us</div>
                        <p className="text-slate-500">Questions, corrections or feedback?</p>
                        <a href={`mailto:${cfg.support_email}`} className="text-[#1E3A8A] underline" data-testid="footer-support-email">
                            {cfg.support_email}
                        </a>
                    </div>
                </div>
                <div className="mt-8 pt-6 border-t border-slate-200 text-xs text-slate-400">© 2026 CCS Cost Calculator Australia</div>
            </div>
        </footer>
    );
}
